export  // Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAQB6RMDmg8zK_T8MthZXL9zTSG3miMCqM",
  authDomain: "paddlez-1b260.firebaseapp.com",
  projectId: "paddlez-1b260",
  storageBucket: "paddlez-1b260.appspot.com",
  messagingSenderId: "395800569560",
  appId: "1:395800569560:web:97c9d7b66bcdb609c419ad",
  romero: "QjBQlVqdFSsul0PyHOVlzvayekf4HQGOG8ZPYII2",
  svr: "https://vq0bmxygbla7.usemoralis.com:2053/server"
};



// const firebaseConfig = {
//     apiKey: "AIzaSyC2BCf8Gl7AOAniimmgy2VvTRdf8gPqBhE",
//     authDomain: "punkforce-rarity.firebaseapp.com",
//     projectId: "punkforce-rarity",
//     storageBucket: "punkforce-rarity.appspot.com",
//     messagingSenderId: "1010785487274",
//     appId: "1:1010785487274:web:bac9e45ec62d053bcdc3d3",
//     romero: "QjBQlVqdFSsul0PyHOVlzvayekf4HQGOG8ZPYII2",
//     svr: "https://vq0bmxygbla7.usemoralis.com:2053/server"
//   };
  